'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function SCFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-fktgxued6", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-jtaw7k8j1", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-576sktsme" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-576sktsme", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-fktgxued6)" }, /* @__PURE__ */ React.createElement("use", { fill: "#2e42a5", xlinkHref: "#mantine-576sktsme" }), /* @__PURE__ */ React.createElement("path", { fill: "#ffd018", d: "M0 23.997L16.151-2h16.151z", mask: "url(#mantine-jtaw7k8j1)" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#e31d1c",
        fillRule: "nonzero",
        d: "M0 23.997l34.463-12.999V-5.103z",
        mask: "url(#mantine-jtaw7k8j1)"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#f7fcff",
        fillRule: "nonzero",
        d: "M0 23.997l34.463-4.999v-8.101z",
        mask: "url(#mantine-jtaw7k8j1)"
      }
    ), /* @__PURE__ */ React.createElement("path", { fill: "#5eaa22", d: "M0 23.997h34.463v-7.1z", mask: "url(#mantine-jtaw7k8j1)" })))
  );
}

export { SCFlag };
//# sourceMappingURL=SC.mjs.map
